import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import '../custom.scss';
import { pageStyleA4ToPrint } from '@app/const/AppSetting';
import * as mainService from '@app/services/mainService';
import {useTranslation} from "react-i18next";

const Card = ({
	children,
	id,
	title,
	keyName,
	isDefaultActive,
	onApprove,
	onClick,
	onDelete,
	onEdit,
	onRefuse,
	printObj,
	printDetailObj,
}) => {
	const [className, setClassName] = useState('card card-default');
	const [isActive, setIsActive] = useState(isDefaultActive);
	const [soLanIn, setSoLanIn] = useState(0);
	const [soLanInDetail, setSoLanInDetail] = useState(0);
	const printComponentRef = useRef();
	const printDetailComponentRef = useRef();
	const [t] = useTranslation();
	useEffect(async () => {
		if (isActive) setClassName('card card-primary');
		else setClassName('card card-secondary collapsed-card');
	}, [isActive]);

	const handleApprove = () => {
		onApprove && onApprove(id);
	};

	const handleRefuse = () => {
		onRefuse && onRefuse(id);
	};

	const handleClick = () => {
		setIsActive(!isActive);
		onClick && onClick(id);
	};

	const handleDelete = () => {
		onDelete && onDelete(id);
	};

	const handleEdit = () => {
		onEdit && onEdit(id);
	};

	const handlePrint = useReactToPrint({
		content: () => printComponentRef.current,
		pageStyle: pageStyleA4ToPrint,
		onBeforeGetContent: () => { return new Promise(async (resolve, reject) => {
			if ( window.confirm(t('fields.label.bancomuonin'))) {
				await mainService.postSolanin('CHIDINHCLS', id);
				resolve();
			} else {
				reject();
			} 
		})},
		onAfterPrint: () => { setSoLanIn(prev => prev + 1); }
	});
	
	const handlePrintDetail = useReactToPrint({
		content: () => printDetailComponentRef.current,
		pageStyle: pageStyleA4ToPrint,
		onBeforeGetContent: () => { return new Promise(async (resolve, reject) => {
			if ( window.confirm(t('fields.label.bancomuonin'))) {
				await mainService.postSolanin('CHIDINHCHITIETCLS', id);
				resolve();
			} else {
				reject();
			} 
		})},
		onAfterPrint: () => { setSoLanInDetail(prev => prev + 1); }
	});

	return (
		<div key={`card-${keyName}-${id}`} className={className}>
			<div className="card-header pointer" onClick={handleClick}>
				<h3 className="card-title">{title}</h3>
			</div>
			<div className="card-edit">
				<button className={`btn btn-warning pt-0 pb-0 mr-1 ${onEdit ? '' : 'd-none'}`} onClick={handleEdit}>
					<i className="fa fa-edit"> {t('action.label.edit')}</i>
				</button>
				<button
					className={`btn btn-success pt-0 pb-0 mr-1 ${onApprove ? '' : 'd-none'}`}
					onClick={handleApprove}>
					<i className="fas fa-check-circle"> {t('action.label.approve')}</i>
				</button>
				<button
					className={`btn btn-warning pt-0 pb-0 mr-1 ${onRefuse ? '' : 'd-none'}`}
					onClick={handleRefuse}>
						<i className="fa fa-lock-open"> {t('action.label.unapprove')}</i>
					
				</button>
				<button className={`btn btn-danger pt-0 pb-0 mr-1 ${onDelete ? '' : 'd-none'}`} onClick={handleDelete}>
					<i className="fa fa-trash"> {t('action.label.delete')}</i>
				</button>
				<button className={`btn btn-secondary pt-0 pb-0 mr-1 ${printObj ? '' : 'd-none'}`} onClick={handlePrint}>
					<i className="fa fa-print"> {t('action.label.print')}</i>
				</button>
				<button
					className={`btn btn-secondary pt-0 pb-0 mr-1 ${printDetailObj ? '' : 'd-none'}`}
					onClick={handlePrintDetail}>
					<i className="fa fa-print"> {t('action.label.print')+' - '+t('fields.label.detail')}</i>
				</button>
			</div>
			{children}
			{keyName === 'chidinhcls' && printObj && (
				<div style={{ display: 'none' }}>
				{/*	<PrintCLS id={id} printObj={printObj} print={soLanIn} ref={printComponentRef} />*/}
				</div>
			)}
			{keyName === 'chidinhcls' && printDetailObj && (
				<div style={{ display: 'none' }}>
				{/*	<PrintDetailCLS id={id} printObj={printDetailObj} print={soLanInDetail} ref={printDetailComponentRef} />*/}
				</div>
			)}
		</div>
	);
};

export default Card;
